import { Component, Input, OnInit, Inject, Optional } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'kt-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.css']
})
export class WarningModalComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string = 'OK';
  @Input() btnCancelText: string = 'Cancel';
  @Input() errorType:string;

  constructor(private dialogRef: MatDialogRef<WarningModalComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    if(this.data){
    this.title = this.data.title;
    this.message = this.data.message;
    this.errorType = this.data.type
  }
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }
}
